import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: 100vh;

    display: flex;
    flex-direction: column;

    background-color: ${theme.colors.white.Branco};

    @media (max-width: 768px) {
        height: auto;
    }
`;

export const ContainerContentSimulation = styled.div`
    width: 100%;
    height: 100%;
    padding: 0 32px; 

    display: flex;
    justify-content: center;
    align-items: flex-start;

    @media (max-width: 768px) {
        padding: 0;
    }
`

export const ContentSimulation = styled.div`
    width: 100%;
    height: auto;
    padding: 32px;
    max-width: 640px;

    gap: 32px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;

    border-radius: 16px;
    border: ${({ acordionError }) => acordionError ? `2px solid ${theme.colors.red.Vermelho_erro}` : `2px solid ${theme.colors.gray.Cinza_12}`};

    >h6{
        width: 100%;

        text-align: left;
    }
`

export const Divider = styled.div`
    width: 100%;
    height: 2px;

    background-color: ${theme.colors.gray.Cinza_12};
`

export const ContainerInputs = styled.div`
    width: 100%;
    height: auto;
    max-width: 420px;

    gap: 24px;
    display: flex;
    flex-direction: column;

    >div:nth-of-type(1) {
        >div>div>select {
            color: ${theme.colors.gray.Cinza_2} !important;
        }
    }

    >div:nth-of-type(2) {
        >div>input {
            text-transform: uppercase;
        }
    }

    >div:nth-of-type(2) >div{
    input:-webkit-autofill { 
      transition: background-color 600000s 0s !important;
    }

    >button{
      top: ${({extraInfo}) => extraInfo ? '42% !important' : '55% !important'};
    }
    }
`

export const ContainerCardPlans = styled.div`
    width: 100%;
    height: auto;

    gap: 24px;
    display: flex;
    justify-content: center;

    @media (max-width: 479px) {
        gap: 24px;
        flex-direction: column;
    }
`

export const CardPlans = styled.div`
    width: 192px;
    height: auto;
    padding: 16px;

    gap: 16px;
    display: flex;
    flex-direction: column;

    cursor: pointer;
    border-radius: 16px;
    border: 4px solid ${({ selected }) => selected ? theme.colors.green.Verde_AgroReceita : theme.colors.gray.Cinza_12};

    .radio-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;

        cursor: pointer;
    }

    input[type="radio"] {
        display: none;
    }

    .custom-radio {
        position: relative;

        width: 16px;
        height: 16px;

        display: inline-block;

        cursor: pointer;
        border-radius: 50%;
        background: ${theme.colors.gray.Cinza_12};
        border: 1px solid ${theme.colors.gray.Cinza_8};;
    }

    input[type="radio"]:checked + .custom-radio {
        border-color: ${theme.colors.green.Verde_AgroReceita};
        background-color: ${theme.colors.green.Verde_AgroReceita};
    }

    input[type="radio"]:checked + .custom-radio::after {
        content: '';
        top: 50%;
        left: 50%;
        position: absolute;

        width: 6px;
        height: 6px;

        background: white;
        border-radius: 50%;
        transform: translate(-50%, -50%);
    }

    @media (max-width: 479px) {
        width: 100%;
    }
`

export const CardPlansHeader = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    flex-direction: column;
`

export const CardPrice = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    flex-direction: column;

    >p:first-child{
        text-decoration: line-through;
        font-size: 13px;
    }
`

export const CardFooter = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    flex-direction: column;

    >p{
        text-align: center;
        
        >b{
            font-weight: ${theme.typography.fontWeight.bold};
        }
    }
`